import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
/** @jsx jsx */

import { jsx, Flex } from 'theme-ui';
import { Link, useConfig } from 'docz';
import * as styles from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Logo = function Logo() {
  var config = useConfig();
  return jsx(Flex, {
    aligmItems: "center",
    sx: styles.logo,
    "data-testid": "logo"
  }, jsx(Link, {
    to: "/",
    sx: styles.link
  }, config.title));
};

if (typeof Logo !== 'undefined' && Logo && Logo === Object(Logo) && Object.isExtensible(Logo) && !Logo.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Logo, '__filemeta', {
    configurable: true,
    value: {
      name: "Logo",
      filename: "node_modules/gatsby-theme-docz/src/components/Logo/index.js"
    }
  });
}